import { Card, CardContent } from '@components/card';
import { CreateAcquirerUserForm } from '@components/forms/acquirerUsers/create';
import { useCreateAcquirerUserForm } from '@hooks/forms/acquirerUsers/createForm';
import { BaseLayout } from '@layouts/base';
import { useCreateAcquirerUser } from '@services/acquirer/users/create';
import { useGetAcquirerUser } from '@services/acquirer/users/get';
import {
  createFileRoute,
  redirect,
  useNavigate,
  useParams,
  useSearch,
} from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export function NewAcquirerUser() {
  const { t } = useTranslation('app');
  const { localId } = useParams({ from: '/u/$localId/_acquirer/acquirer/users/new' });
  const { duplicateFrom } = useSearch({ strict: false });
  const navigate = useNavigate();
  const { data: sourceUser } = useGetAcquirerUser(duplicateFrom || '');

  const requestHandler = useCreateAcquirerUser({
    callback: () => {
      toast.success(t('toast.users.createSuccess'));
      navigate({
        to: '/u/$localId/acquirer/users',
        params: { localId: localId || '0' },
        replace: true,
      }).catch((err) => {
        console.error(err);
      });
    },
  });
  const formObj = useCreateAcquirerUserForm({ user: sourceUser, requestHandler });

  return (
    <BaseLayout isChild title={t('pages.newAcquirerUser.title')}>
      <Card>
        <CardContent className="p-6">
          <CreateAcquirerUserForm formObj={formObj} />
        </CardContent>
      </Card>
    </BaseLayout>
  );
}

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/users/new')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['acquirer_users_create'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: NewAcquirerUser,
});
